import { useTranslation } from 'react-i18next';

import AccessoryCategory from 'classes/StandingData/AccessoryCategory/AccessoryCategory';

interface IProps {
	accessoryCategory: AccessoryCategory;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	selectedLanguage: string;
}

const AccessoryCategoryLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:DESCRIPTION')}</label>
							<div>
								<input
									value={
										props.accessoryCategory.nameTranslations[
											props.selectedLanguage
										] || ''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="descriptions"
									error-key={'Descriptions'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default AccessoryCategoryLanguageInput;
